import { render } from "./PolicyEdit.vue?vue&type=template&id=7df115b4&scoped=true&ts=true"
import script from "./PolicyEdit.vue?vue&type=script&lang=ts"
export * from "./PolicyEdit.vue?vue&type=script&lang=ts"

import "./PolicyEdit.vue?vue&type=style&index=0&id=7df115b4&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7df115b4"]])

export default __exports__